import { motion } from "framer-motion";
import podImage from "../assets/pod-design.png";

const PartnerAd = () => {
  return (
    <div className="h-screen bg-background flex flex-col items-center justify-between px-6 py-8 overflow-hidden relative">
      {/* Subtle background glow */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          background: "radial-gradient(circle at 50% 40%, hsl(var(--foreground)) 0%, transparent 60%)"
        }}
      />

      {/* Top: The hook - identify the audience */}
      <motion.p
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
        className="text-foreground text-center text-2xl font-medium leading-snug mt-8"
      >
        Got 1m² of spare space
        <br />
        in London?
      </motion.p>

      {/* Center content */}
      <div className="flex flex-col items-center flex-1 justify-center -mt-8">
        {/* Pod image - slides in */}
        <motion.img
          src={podImage}
          alt="qwip soundproof pod"
          initial={{ opacity: 0, x: 60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.35, type: "spring", stiffness: 100 }}
          className="w-36 drop-shadow-xl mb-4"
        />

        {/* Value proposition */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.35, delay: 0.65 }}
          className="text-muted-foreground text-base mb-1"
        >
          Host a qwip pod, and earn up to
        </motion.p>

        {/* THE MONEY - big and bold */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.45, delay: 0.85, type: "spring", stiffness: 120 }}
          className="text-center mb-1"
        >
          <p className="font-funnel text-6xl font-bold text-foreground">£3,000</p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 1.05 }}
          className="text-muted-foreground text-base mb-5"
        >
          per month
        </motion.p>

        {/* Trust builder - single bubble */}
        <motion.span
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35, delay: 1.2 }}
          className="bg-foreground/10 text-foreground text-sm font-medium px-4 py-2 rounded-full"
        >
          Zero upfront cost
        </motion.span>
      </div>

      {/* Bottom: Logo and tagline */}
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 1.35 }}
        className="text-center mb-4"
      >
        <span className="font-funnel text-2xl font-bold text-foreground">qwip</span>
        <p className="font-cormorant italic text-foreground/80 text-lg font-semibold mt-1">
          bookable, quiet pods - wherever you go.
        </p>
      </motion.div>
    </div>
  );
};

export default PartnerAd;
